export default __webpack_public_path__ + "static/media/CTP_Dark_ZH.f10aebfd.svg";